export default __webpack_public_path__ + "static/media/rnr-sports-table-23.08921c6b.webp";